import React from 'react';
import { Flex, Box } from 'reflexbox';
import _ from 'lodash';
import { IconButton, FlatButton, Menu, MenuItem, Popover } from 'material-ui';
import injectSheet from 'react-jss';
import SparkScroll from '../config/Scrolly';
import HashService from '../services/HashService';
import AppService from '../services/AppService';

class SubTopMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      anchorEl: null
    }
  }

  render() {
    const { classes, hash } = this.props;

    let shownHash;
    if (hash) {
      shownHash = hash.replace('#', '');
      if (['#Who', '#Employee'].includes(hash)) shownHash = 'Who';
      else if (['#Why', '#Passion'].includes(hash)) shownHash = 'Why';
      else if (['#Join', '#Project'].includes(hash)) shownHash = 'Join';
      else if (['#Find', '#Location'].includes(hash)) shownHash = 'Find';
    }

    const functions = ['Who', 'Work', 'Why', 'Join', 'Find'];

    return <SparkScroll.div style={styles.container}>
      <Flex justify='space-between'>
        <Box auto>
          <IconButton style={styles.iconButton} onClick={() => this.onScrollTo('Home')}>
            <img src={require('../static/Assets/Images/Home/Chi.png')} width={73} alt='logo' />
          </IconButton>
        </Box>
        <Box wrap pt={5} flex align='center'>
          <FlatButton style={{ width: 10 }}
            onClick={this.onOpen}
            icon={<img src={require('../icons/menu.svg')} width={40} alt='menu' />} />

          <Popover
            style={{ background: 'red', textAlign: 'right' }}
            open={this.state.open}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{ "horizontal": "left", "vertical": "bottom" }}
            targetOrigin={{ "horizontal": "middle", "vertical": "top" }}
            onRequestClose={this.handleRequestClose}
          >
            <Menu style={{ paddingTop: 30 }}>
              {
                _.map(functions, value =>
                  <MenuItem style={shownHash === value ? { fontWeight: 'bold', textDecoration: 'underline', color: 'white' } : styles.menuItem}
                    primaryText={value}
                    key={value}
                    onClick={() => this.onScrollTo(value)}
                    className={classes.hover}
                  >
                  </MenuItem>
                )
              }
            </Menu>
          </Popover>
        </Box>
      </Flex>
    </SparkScroll.div>
  }

  onOpen = (event) => {
    event.preventDefault();
    this.setState({ open: true, anchorEl: event.currentTarget });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
  }

  onScrollTo = (component) => {
    HashService.setParentPage(component);
    AppService.gotoPage('/');
  }
}

const css = () => ({
  hover: {
    '&:hover': {
      textDecoration: 'underline !important',
    }
  }
})

const styles = {
  container: {
    top: 0,
    zIndex: 99999,
    position: 'sticky',
    marginLeft: -15,
    marginRight: -15,
    background: 'white'
  },
  menuButton: {
    textTransform: 'none',
    fontWeight: 'normal',
    // fontSize: 16
  },
  pageSelected: {
    textDecoration: 'underline',
    fontWeight: 'bolder'
  },
  menuItem: {
    color: 'white',
    width: 100
  },
  shownComponent: {
    fontFamily: 'UTMAvoBold',
    textDecoration: 'underline',
    fontWeight: 'bold'
  },
  iconButton: {
    width: 100,
    height: 100,
  }
}

export default injectSheet(css)(SubTopMenu);


// WEBPACK FOOTER //
// ./src/components/SubTopMenu.js